<!-- 
	Greeting
	props: User
	role: User 
	Display current ticket packages to user who is enrolled in lottery 
	If awaiting optout processing display that and date of request
	If opted out of lottery display CTA to join
-->

<template>
	<div
		class="
      greeting
      flex
      items-stretch
      flex-col
      sm:flex-row
      justify-between
      text-center
      sm:text-left
      pb-4
    "
	>
		<div
			class="
        text-3xl
        sm:mr-4
        py-6
        px-2
        sm:p-4
		my-4 
		sm:my-0
        w-full
        sm:w-1/3
        flex-1
        text-center
        bg-purple
      "
		>
			<div
				v-if="
					user.apiData.Profile.Year2022 &&
						user.apiData.Profile.Year2022OptOut === false
				"
			>
				<div class="pb-2">You are currently</div>
				<div class="uppercase underline">Enrolled</div>
			</div>
			<div v-else>
				<div class="pb-2">You are currently</div>
				<div class="uppercase underline">not enrolled</div>
				<div v-if="open">
					<span class="text-base font-bold winwin-gold2"
						><router-link to="/enroll-now">Enroll Now</router-link></span
					>
				</div>
				<div v-else>
					<span class="text-base font-bold"
						>Lottery Enrollment will open on 12/16/2021</span
					>
				</div>
			</div>
		</div>
		<div
			class="py-6 px-2 sm:p-4 w-full mb-4 sm:mb-0 sm:w-1/3 flex-1 bg-purple"
			v-if="
				user.apiData.Profile.Year2022 &&
					user.apiData.Profile.Year2022OptOut === false
			"
		>
			<div class="font-bold">Current Ticket Package:</div>
			<div
				v-if="
					user.apiData.Profile.CurrentMainTicketPackage == 40 ||
						user.apiData.Profile.NewMainTicketPackage == 40
				"
			>
				<div>
					<span class="font-bold">WinWin Staff Lottery:</span> Sets of 40
					Tickets for $40
				</div>
			</div>
			<div
				v-if="
					user.apiData.Profile.CurrentMainTicketPackage == 30 ||
						user.apiData.Profile.NewMainTicketPackage == 30
				"
			>
				<div>
					<span class="font-bold">WinWin Staff Lottery:</span> Sets of 15
					Tickets for $30
				</div>
			</div>
			<div
				v-if="
					user.apiData.Profile.CurrentMainTicketPackage == 20 ||
						user.apiData.Profile.NewMainTicketPackage == 20
				"
			>
				<div>
					<span class="font-bold">WinWin Staff Lottery:</span> Sets of 8 Tickets
					for $20
				</div>
			</div>
			<div
				v-if="
					user.apiData.Profile.CurrentMainTicketPackage == 10 ||
						user.apiData.Profile.NewMainTicketPackage == 10
				"
			>
				<div>
					<span class="font-bold">WinWin Staff Lottery:</span> Sets of 3 Tickets
					for $10
				</div>
			</div>
			<div
				v-if="
					user.apiData.Profile.CurrentMainTicketPackage == 5 ||
						user.apiData.Profile.NewMainTicketPackage == 5
				"
			>
				<div>
					<span class="font-bold">WinWin Staff Lottery:</span> Single Ticket for
					$5
				</div>
			</div>
			<div
				v-else-if="
					user.apiData.Profile.CurrentMainTicketPackage == null &&
						user.apiData.Profile.NewMainTicketPackage == null
				"
			>
				No WinWin Staff Lottery Ticket Package Selected
			</div>
			<div
				v-if="
					user.apiData.Profile.Current5050TicketPackage == 35 ||
						user.apiData.Profile.New5050TicketPackage == 35
				"
			>
				<div>
					<span class="font-bold">Quarterly Cash 50/50:</span> Sets of 35
					Tickets for $35
				</div>
			</div>
			<div
				v-if="
					user.apiData.Profile.Current5050TicketPackage == 25 ||
						user.apiData.Profile.New5050TicketPackage == 25
				"
			>
				<div>
					<span class="font-bold">Quarterly Cash 50/50:</span> Sets of 16
					Tickets for $25
				</div>
			</div>
			<div
				v-if="
					user.apiData.Profile.Current5050TicketPackage == 10 ||
						user.apiData.Profile.New5050TicketPackage == 10
				"
			>
				<div>
					<span class="font-bold">Quarterly Cash 50/50:</span> Sets of 4 Tickets
					for $10
				</div>
			</div>
			<div
				v-if="
					user.apiData.Profile.Current5050TicketPackage == 5 ||
						user.apiData.Profile.New5050TicketPackage == 5
				"
			>
				<div>
					<span class="font-bold">Quarterly Cash 50/50:</span> Single Ticket for
					$5
				</div>
			</div>
			<div
				v-else-if="
					user.apiData.Profile.Current5050TicketPackage == null &&
						user.apiData.Profile.New5050TicketPackage == null
				"
			>
				No Quarterly Cash 50/50 Ticket Package Selected
			</div>
			<div>
				<span class="font-bold">Next Cutoff Date: </span>
				<span>
					{{ dateTime(nextDraw()) }}
				</span>
			</div>
			<div
				v-if="
					user.apiData.Profile.Current5050TicketPackage !== null ||
						user.apiData.Profile.New5050TicketPackage !== null ||
						user.apiData.Profile.CurrentMainTicketPackage !== null ||
						user.apiData.Profile.NewMainTicketPackage !== null
				"
				class="text-sm"
			>
				Deductions are made each pay period
			</div>
		</div>
		<div
			v-else
			class="py-6 px-2 sm:p-4 w-full mb-4 sm:mb-0 sm:w-1/3 flex-1 bg-purple text-center"
		>
			<div class="font-bold">
				When you buy a WinWin Staff Lottery ticket, proceeds are directly
				invested back to Alberta Area Hospitals.
			</div>
			<CustomButton id="cb-gold"><a href="#">Learn More</a></CustomButton>
		</div>
	</div>
</template>
<script>
	import { mapGetters } from "vuex";
	import moment from "moment";

	import CustomButton from "@/components/CustomButton";

	export default {
		name: "Greeting",
		components: {
			CustomButton,
		},
		computed: {
			...mapGetters({
				user: "user",
			}),
		},
		data() {
			return {
				open: null,
			};
		},
		async created() {
			let open = moment("2021-12-16");

			let now = moment();

			if (now >= open) {
				this.open = true;
			} else {
				this.open = false;
			}
		},
		methods: {
			nextDraw() {
				// calculate upcoming draw date
				const drawDates = [
					"01/11/2022",
					"01/25/2022",
					"02/08/2022",
					"02/22/2022",
					"03/08/2022",
					"03/22/2022",
					"04/05/2022",
					"04/19/2022",
					"05/03/2022",
					"05/17/2022",
					"05/31/2022",
					"06/14/2022",
					"06/28/2022",
					"07/12/2022",
					"07/26/2022",
					"08/09/2022",
					"08/23/2022",
					"09/06/2022",
					"09/20/2022",
					"10/04/2022",
					"10/20/2022",
					"11/01/2022",
					"11/15/2022",
					"11/29/2022",
					"12/13/2022",
					"12/27/2022",
				];

				let next;

				drawDates.forEach((date) => {
					let diff = moment(date).diff(moment(drawDates), "days");
					if (diff > 0) {
						if (next) {
							if (moment(date).diff(moment(next), "days") < 0) {
								next = date;
							}
						} else {
							next = date;
						}
					}
				});

				return next;
			},

			dateTime(value) {
				// format Date object to readible format
				return moment(value).format("MMMM Do, YYYY");
			},
		},
	};
</script>
<style scoped>
	.bg-purple {
		background-color: #1a1f56;
	}
</style>
